import React from 'react';
import "./ClientLayout.scss";
import { useAuth } from '../../hook';
import { LoginClient } from '../../pages/Client/LoginClient';


export function ClientLayout(props) {

  const {children} = props;
  const { auth } = useAuth();

  if (!auth) return <LoginClient />;

  return (
    <div className="client-layout">
        {children}
    </div>
  )
}
